export default __webpack_public_path__ + "static/media/my-files.608fb356.svg";